<ng-template #deleteAcknowlegeModal>
  <div class="card deletePopup" [ngClass]="isMultiSkuDelete ? 'delete-skus':''">
    <div class="modal-header">
      <div (click)="dismissModal()" class="close_icon">
        <img src="assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div class="modal-body popup-body" *ngIf="!isSystemIDDeleteCnfrm">
      <img class="tick_img" alt="tick image"/>
      <h2><span i18n="@@delete-acknowledgement-popup.deleted-text">Deleted</span></h2>
      <div *ngIf="!isStoreDeleteCnfrm && !isMultiStoreDeleteCnfrm && !isMultiSkuDelete" class="card_desc">
        <span i18n="@@delete-acknowledgement-popup.deleted-msg">{{sourceString}} has been deleted</span>
      </div>
      <div *ngIf="isStoreDeleteCnfrm && !isMultiStoreDeleteCnfrm" class="card_desc">
        <span i18n="@@delete-acknowledgement-popup.deleted-permanently-msg">{{sourceString}} has been deleted permanently</span>
      </div>
      <div *ngIf="isMultiStoreDeleteCnfrm" class="card_desc">
        <span>{{globalConst.POPUP_ACK_BODY_TEXT}}</span>
      </div>
      <div *ngIf="isMultiSkuDelete" class="card_desc">
        <span>{{(tabbIndex.length > 1) ? 'Selected SKUs have been deleted.': deleteSelectedSkuText}}</span>
      </div>
    </div>
    <div *ngIf="isSystemIDDeleteCnfrm && isMultisystemIddelete" class="modal-body popup-body">
      <img class="delete_submit_icon" alt="submit image"/>
      <div class="card_desc">
        <span>Request to delete selected System ID is submitted to Detection Engine.</span>
      </div>
    </div>
    <div *ngIf="isSystemIDDeleteCnfrm && !isMultisystemIddelete" class="modal-body popup-body">
      <img class="delete_submit_icon" alt="submit image"/>
      <div class="card_desc">
        <span>Request to delete selected System IDs is submitted to Detection Engine.</span>
      </div>
    </div>
  </div>
</ng-template>